<template>
  <div class="Market">
    <el-tabs v-model="active_name" type="card" @tab-click="handleClick">
      <el-tab-pane label="Brand List" name="first">
        <BrandList v-if="active_name==='first'"></BrandList>
      </el-tab-pane>
      <el-tab-pane label="Create Brand" name="second">
        <BrandCreate @back="onListTap" v-if="active_name==='second'" bid="0"></BrandCreate>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import BrandList from "@/components/Brand/BrandList/BrandList";
  import BrandCreate from "@/components/Brand/BrandCreate/BrandCreate";
  export default {
    props: {},
    components:{
      BrandList,
      BrandCreate
    },
    data: () => {
      return {
        active_name: 'first'
      }
    },
    methods: {
      onListTap(){
        this.active_name = 'first'
      },
      handleClick(tab) {
        this.active_name = tab.paneName
      }
    },
    beforeMount(){
      this.active_name = this.$route.params.target?this.$route.params.target: "first"
    },
  };

</script>
